/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { FilterableByYMM } from '../../interface/models';

export const isFilterableByYMM = (item: unknown): item is FilterableByYMM => {
  if (!item) {
    return false;
  }

  return Boolean(
    typeof item === 'object' &&
    'ymm_filter' in item &&
    item.ymm_filter &&
    'ymm_selector' in item &&
    item.ymm_selector &&
    typeof item.ymm_selector === 'object' &&
    'selectedItems' in item.ymm_selector &&
    Array.isArray(item.ymm_selector.selectedItems),
  );
};
